import React, { useState } from 'react'
import { Form, Divider, Switch, Input } from 'antd'

import SeatingScheme from '../../CreateTemplate/GeneralInfo/SeatingScheme'
import Categories from '../../CreateTemplate/PriceCategories/Categories'
import AssignSeating from '../OptionsEvent/AssignSeating'
import InfoTooltip from 'images/BlueInformationToolTip.svg'
import ArrowImg from 'images/red-arrow.svg'
import './index.styl'
const { List, Item } = Form

const ManualCreationSeating = ({ templateCover, setTemplateCover }) => {
  const [saveTemplate, setSaveTemplate] = useState(false)
  const saveTemplateHandler = () => {
    setSaveTemplate(!saveTemplate)
  }
  return (
    <div>
      <div className='titleGeneral'>General Info</div>
      <SeatingScheme templateCover={templateCover?.thumbnail1} setTemplateCover={setTemplateCover} />
      <div className='containerTitle mt-3'>Price Categories</div>
      <List name='templateCategories'>
        {(fields, { add, remove }) => (
          <div className='priceCatMap'>
            {fields.map((field, i) => {
              return (
                <div key={field.name}>
                  <div className='categoryLabel'>Category {field.name + 1}</div>
                  <Categories
                    field={{ ...field, key: `${field?.name}` }}
                    key={[field?.name]}
                    onRemove={remove}
                  />
                </div>
              )
            },
            )}
            <div
              id='addPriceCategory' className='btn' onClick={() => {
                add()
              }}
            >Add New Price Category
            </div>
          </div>)}
      </List>
      <List name='templateSections'>
        {(fields, { add, remove }) => (
          <div className='priceCatMap'>
            <div className='seatingWrapper'>
              {fields.map(field => (<AssignSeating key={field.key} field={field} remove={remove} />))}
            </div>
            <div id='addSections' className='btn sectionBtn' onClick={() => add()}>Add New Section</div>
          </div>
        )}
      </List>
      <Divider />
      <div className='additionalSettingWrap'>
        <img alt='InfoTooltip' src={InfoTooltip} />
        <div>
          <div className='additionalSettingsLabel'>You can make additional settings of the seating scheme after creating the event.</div>
          <div>
            <span className='infoPath'><span>My box Office </span><img src={ArrowImg} alt='arrowRed' /><span> The Event </span> <img src={ArrowImg} alt='arrowRed' /> <span>Assigned Seatings</span> </span>
          </div>
        </div>
      </div>
      <Divider />
      <div className='radioItem'>
        <Item
          name='saveTemplate'
          initialValue={saveTemplate}
          valuePropName='checked'
          className='item noGutter'
        >
          <Switch onChange={saveTemplateHandler} defaultChecked={saveTemplate} />
        </Item>
        <div className='text'>Save the seating scheme in my templates</div>
      </div>
      {saveTemplate &&
        <Item
          rules={[{ required: true, message: 'Template Name is required' }]}
          label='Template Name'
          className='item templateName'
          name='templateName'
          normalize={v => v.trimStart()}
        >
          <Input placeholder='Name' className='input' />
        </Item>}
    </div>
  )
}

export default ManualCreationSeating
